"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedChatTableComponents = exports.ChatThead = exports.ChatTh = exports.ChatTd = exports.ChatTableScrollContainer = exports.ChatTable = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "className"],
  _excluded2 = ["children", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var TABLE_CLASSES = "border-collapse w-max min-w-full text-sm";
var THEAD_CLASSES = "sticky top-0 z-10 bg-background-subtle";
var TH_CLASSES = "border border-border-default px-3 py-2 text-left bg-background-subtle font-semibold " + "[&:first-child]:sticky [&:first-child]:left-0 [&:first-child]:z-20";
var TD_CLASSES = "border border-border-default px-3 py-2 text-left bg-background-card " + "[&:first-child]:sticky [&:first-child]:left-0 [&:first-child]:z-[1]";
var SCROLL_CONTAINER_CLASSES = "my-4 max-h-[60vh] overflow-auto subtle-scrollbar rounded-lg border border-border-default";
// w-max tables never wrap cell text on their own; the inner div caps column
// width and restores wrapping (max-width on td isn't honored by auto layout).
var CELL_CONTENT_CLASSES = "max-w-[400px] [overflow-wrap:anywhere]";
var ChatTable = exports.ChatTable = function ChatTable(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("table", {
    className: TABLE_CLASSES,
    "data-sentry-component": "ChatTable",
    "data-sentry-source-file": "sharedChatTableComponents.tsx",
    children: children
  });
};
var ChatThead = exports.ChatThead = function ChatThead(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("thead", {
    className: THEAD_CLASSES,
    "data-sentry-component": "ChatThead",
    "data-sentry-source-file": "sharedChatTableComponents.tsx",
    children: children
  });
};
var ChatTh = exports.ChatTh = function ChatTh(_ref3) {
  var children = _ref3.children,
    className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("th", _objectSpread(_objectSpread({}, props), {}, {
    className: className ? "".concat(TH_CLASSES, " ").concat(className) : TH_CLASSES,
    "data-sentry-component": "ChatTh",
    "data-sentry-source-file": "sharedChatTableComponents.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: CELL_CONTENT_CLASSES,
      children: children
    })
  }));
};
var ChatTd = exports.ChatTd = function ChatTd(_ref4) {
  var children = _ref4.children,
    className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("td", _objectSpread(_objectSpread({}, props), {}, {
    className: className ? "".concat(TD_CLASSES, " ").concat(className) : TD_CLASSES,
    "data-sentry-component": "ChatTd",
    "data-sentry-source-file": "sharedChatTableComponents.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: CELL_CONTENT_CLASSES,
      children: children
    })
  }));
};
var ChatTableScrollContainer = exports.ChatTableScrollContainer = function ChatTableScrollContainer(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: SCROLL_CONTAINER_CLASSES,
    "data-sentry-component": "ChatTableScrollContainer",
    "data-sentry-source-file": "sharedChatTableComponents.tsx",
    children: children
  });
};
var sharedChatTableComponents = exports.sharedChatTableComponents = {
  thead: ChatThead,
  th: ChatTh,
  td: ChatTd
};